import { render, staticRenderFns } from "./performance-measure-list.vue?vue&type=template&id=45730476"
import script from "./performance-measure-list.vue?vue&type=script&lang=js"
export * from "./performance-measure-list.vue?vue&type=script&lang=js"
import style0 from "./performance-measure-list.vue?vue&type=style&index=0&id=45730476&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports